var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fsc-modal',_vm._b({attrs:{"modal-id":_vm.modalId},on:{"ok":function($event){return _vm.$emit('ok')}}},'fsc-modal',_vm.$attrs,false),[_vm._v(" Möchtest du diese Ausbildung unwiderruflich löschen? ")])}
var staticRenderFns = []

export { render, staticRenderFns }